const CALCULATED_DUES = 'CALCULATED_DUES';
export const GET_CALCULATED_DUES = `GET_${CALCULATED_DUES}`;
export const SET_CALCULATED_DUES = `SET_${CALCULATED_DUES}`;
